export default "__VITE_ASSET__bcfd803b__"